import React, { useState, useEffect } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { CreateVehicleModalList } from '../../../constants';
import { useUser } from '../../../hooks/useUser';

import { getDeliver } from '../../../service/api/Deliver/apiDeliver';

const CreateVehicleModal = ({ onSubmit, onCancel, mode: propMode = 'personal', companies = [], drivers = [] }) => {
    // 如果 propMode = 'deliver'，讓用戶選擇 mode；否則直接使用 propMode
    const [selectedMode, setSelectedMode] = useState(propMode === 'deliver' ? 'personal' : propMode);
    const mode = propMode === 'deliver' ? selectedMode : propMode;

    const [form, setForm] = useState({
        plate: '',
        model: '',
        tonnage: '',
        employeeId: null,
        company: '',
        hasTailLift: 0,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleCompanyChange = (e) => {
        const value = e.target.value;
        setForm(prev => ({ ...prev, company: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(form);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <h5 className="modal-title">新增車輛</h5>
                        <button className="btn-close" onClick={onCancel}></button>
                    </div>

                    <div className="custom-modal-body">
                        {/* 模式選擇 - 只在 propMode = 'deliver' 時顯示 */}
                        {propMode === 'deliver' && (
                            <div className="input-group mb-3">
                                <span className="input-group-text">車輛類型</span>
                                <select
                                    className="form-select"
                                    value={selectedMode}
                                    onChange={(e) => {
                                        setSelectedMode(e.target.value);
                                        // 清空所有表單資訊
                                        setForm({
                                            plate: '',
                                            model: '',
                                            tonnage: '',
                                            employeeId: null,
                                            company: '',
                                            hasTailLift: 0,
                                        });
                                    }}
                                >
                                    <option value="personal">個人車輛</option>
                                    <option value="company">公司車輛</option>
                                </select>
                            </div>
                        )}
                        {CreateVehicleModalList.map(field => (
                            (field.name !== 'employeeId' || mode === 'personal') && (
                                <div className="input-group mb-3" key={field.name}>
                                    {field.type === 'checkbox' ? (
                                        <>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                name={field.name}
                                                checked={form[field.name]}
                                                onChange={handleChange}
                                                id={field.name}
                                            />
                                            <label className="form-check-label ms-2" htmlFor={field.name}>
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </label>
                                        </>
                                    ) : field.type === 'select' && field.isAsync ? (
                                        <>
                                            <span className="input-group-text">
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </span>
                                            <select
                                                className="form-select"
                                                name={field.name}
                                                value={form[field.name] || ''}
                                                onChange={handleChange}
                                                required={field.required}
                                            >
                                                <option value="">請選擇{field.label}</option>
                                                {drivers.map(driver => (
                                                    <option key={driver[field.valueField]} value={driver[field.valueField]}>
                                                        {driver[field.displayField]}
                                                    </option>
                                                ))}
                                            </select>
                                        </>
                                    ) : field.type === 'select' ? (
                                        <>
                                            <span className="input-group-text">
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </span>
                                            <select
                                                className="form-select"
                                                name={field.name}
                                                value={form[field.name]}
                                                onChange={handleChange}
                                                required={field.required}
                                            >
                                                {field.options && field.options.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </>
                                    ) : (
                                        <>
                                            <span className="input-group-text">
                                                {field.label}
                                                {field.required && <span className="required-star">*</span>}
                                            </span>
                                            <input
                                                type={field.type}
                                                className="form-control"
                                                name={field.name}
                                                value={form[field.name]}
                                                onChange={handleChange}
                                                placeholder={field.placeholder || ""}
                                                required={field.required}
                                                step={field.step}
                                            />
                                        </>
                                    )}
                                </div>
                            )
                        ))}

                        {/* 公司選單 - 只在公司模式顯示 */}
                        {mode === 'company' && (
                            <div className="input-group mb-3">
                                <span className="input-group-text">
                                    公司
                                    <span className="required-star">*</span>
                                </span>
                                <select
                                    className="form-select"
                                    value={form.company || ''}
                                    onChange={handleCompanyChange}
                                    required
                                >
                                    <option value="">請選擇公司</option>
                                    {companies.map(company => (
                                        <option key={company.id} value={company.name}>
                                            {company.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* 個人模式時隱藏公司 */}
                        {mode === 'personal' && (
                            <input type="hidden" name="company" value="" />
                        )}
                    </div>

                    <div className="custom-modal-footer">
                        <button className="btn btn-secondary" onClick={onCancel}>取消</button>
                        <button className="btn btn-gradient-primary" type="submit">儲存</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export { CreateVehicleModal };
